import { useState } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Box, CssBaseline, IconButton, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
//
import { Sidebar } from "./Sidebar";
import { ClientProvider } from "../../contexts/ClientContext";
import { TimesheetProvider } from "../../contexts/TimesheetContext";
import { ProfilesProvider } from "../../contexts/ProfilesContext";
import { TabProvider } from "../../contexts/TabContext";
import { NavigationProvider } from "../../contexts/NavigationContext";
const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden"
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingBottom: theme.spacing(10),
  backgroundColor: theme.palette.common.white
}));

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <RootStyle>
      <CssBaseline />
      <ClientProvider>
        <TabProvider>
          <ProfilesProvider>
            <TimesheetProvider>
              <NavigationProvider>
                <Box
                  sx={{
                    display: { sm: "none" },
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1100,
                    backgroundColor: "#1C1D24"
                  }}
                >
                  <Toolbar>
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      edge="start"
                      onClick={handleDrawerToggle}
                      sx={{ mr: 2, color: "white" }}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Toolbar>
                </Box>
                <Sidebar
                  mobileOpen={mobileOpen}
                  onMobileClose={handleDrawerToggle}
                />
                <MainStyle>
                  <Box sx={{ height: { xs: 64, sm: 0 } }} />
                  <Outlet />
                </MainStyle>
              </NavigationProvider>
            </TimesheetProvider>
          </ProfilesProvider>
        </TabProvider>
      </ClientProvider>
    </RootStyle>
  );
}
